export default {
  price_estimation: {
    title: 'Оценка недвижимости',
    summary_title: 'Итоговые показатели',
    avg_label: 'Средняя цена',
    median_label: 'Медианная цена',
    models_title: 'Модели Estimator24',
    not_ready: 'Оценка пока не выполнена',
    ai_prediction: 'Оценка от ИИ',
    market_range: 'Рынок',
    price_label: 'Цена объекта',
    within_range: 'В пределах диапазона',
    above_range: 'Завышено на +{percent}%',
    below_range: 'Ниже рынка на −{percent}%'
  }
}
